class TextTruncate extends HTMLElement {
  connectedCallback() {
    this.style.setProperty('--truncate-lines', this.dataset.lines || '3');

    requestAnimationFrame(() => {
      const content = this.querySelector('.text-block');
      if (!content) return;

      // Only show toggle if content actually overflows
      if (content.scrollHeight <= content.clientHeight) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'text-truncate__toggle';
      button.textContent = this.dataset.more || 'Show more';
      button.addEventListener('click', () => this._toggle(button));
      this.appendChild(button);
    });
  }

  _toggle(button) {
    const expanded = this.hasAttribute('data-expanded');
    if (expanded) {
      this.removeAttribute('data-expanded');
      button.textContent = this.dataset.more || 'Show more';
    } else {
      this.setAttribute('data-expanded', '');
      button.textContent = this.dataset.less || 'Show less';
    }
  }
}

if (!customElements.get('text-truncate')) {
  customElements.define('text-truncate', TextTruncate);
}
